import { useMemo } from "react"
import { useRouter, NextRouter } from "next/router"

type UseUtmParams = () => {
  utmParams: Record<string, string>
  passUtmParams: (url: string) => string
}

const useUtmParams: UseUtmParams = () => {
  const router: NextRouter = useRouter()

  const utmParams = useMemo(() => {
    const keys = Object.keys(router.query).filter((k) => k.startsWith("utm_") || k === "ref")
    let query: Record<string, string> = {}
    keys.forEach((key) => {
      query[key] = router.query[key] as string
    })
    return query
  }, [router.query])

  const marketingParams: string = useMemo(() => {
    return new URLSearchParams(utmParams).toString()
  }, [utmParams])

  // function that takes in a url, parses it, adds marketing params (if there are any) and returns the newly formatted url
  return {
    utmParams: utmParams,
    passUtmParams: (url: string) => {
      if (url.startsWith("/")) {
        return marketingParams ? `${url}?${marketingParams}` : url
      }

      const parsedUrl = new URL(url)
      const existingParams = parsedUrl.searchParams
      const newParams = new URLSearchParams(utmParams)

      newParams.forEach((value, key) => {
        existingParams.set(key, value)
      })

      parsedUrl.search = existingParams.toString()

      return parsedUrl.toString()
    },
  }
}

export default useUtmParams
